import { createEntityAdapter, createSlice, EntityState } from "@reduxjs/toolkit";
import { ShortFlatUserModel } from "./model/ShortFlatUserModel";
import { getUserInfo } from "./helperRequests";


export const userAdapter = createEntityAdapter<ShortFlatUserModel>({
  selectId: (user) => user.id,
  sortComparer: (userA, userB) => userA.fullName.localeCompare(userB.fullName),
});

type HelperState = {

} & EntityState<ShortFlatUserModel>

const initialState: HelperState = {
  ...userAdapter.getInitialState(),
}

export const helperSlice = createSlice({
  name: 'helperSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) =>
    builder.addCase(getUserInfo.fulfilled, (state, action) => {
      userAdapter.upsertMany(state, action.payload);
    })
});

// export const {} = helperSlice.actions;